import { d as s, _ as o } from "./_plugin-vue_export-helper-8568c831.mjs";
import { openBlock as t, createElementBlock as c, normalizeClass as n, normalizeStyle as r, createElementVNode as l } from "vue";
const a = s("share-n"), i = /* @__PURE__ */ l("path", {
  d: "M744.727 992.97H279.273C124.12 992.97 0 868.848 0 713.697V310.303C0 155.152 124.121 31.03 279.273 31.03h108.606c24.824 0 46.545 21.722 46.545 46.546s-21.721 46.545-46.545 46.545H279.273c-102.4 0-186.182 83.782-186.182 186.182v403.394c0 102.4 83.782 186.182 186.182 186.182h465.454c102.4 0 186.182-83.782 186.182-186.182v-400.29c0-24.825 21.721-46.546 46.546-46.546S1024 288.58 1024 313.406v400.291c0 155.151-124.121 279.273-279.273 279.273zM915.394 124.12H667.152c-24.825 0-46.546-21.721-46.546-46.545s21.721-46.546 46.546-46.546h248.242c24.824 0 46.545 21.722 46.545 46.546s-21.72 46.545-46.545 46.545zM515.103 620.606h-9.31c-24.823-6.206-40.338-27.927-37.235-55.854C512 332.024 670.255 139.636 896.776 34.133c24.824-9.309 49.648 0 62.06 21.722 9.31 24.824 0 49.648-21.72 62.06-201.698 93.091-338.231 260.655-378.57 465.455-3.104 21.72-21.722 37.236-43.443 37.236z",
  fill: "currentColor",
  "fill-opacity": "0.9"
}, null, -1), p = [
  i
];
function h(e, m, _, d, f, v) {
  return t(), c("svg", {
    class: n(e.classes),
    style: r(e.style),
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    role: "presentation"
  }, p, 6);
}
const w = /* @__PURE__ */ o(a, [["render", h]]);
export {
  w as default
};
